import { render, staticRenderFns } from "./MenuItemEsmax.vue?vue&type=template&id=533e5244&scoped=true&"
import script from "./MenuItemEsmax.vue?vue&type=script&lang=js&"
export * from "./MenuItemEsmax.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemEsmax.vue?vue&type=style&index=0&id=533e5244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e5244",
  null
  
)

export default component.exports